import React, { Component } from 'react'

export default class CustomTextMessage extends Component {
  render() {
    let {
      txtColor='black',
    } =this.props
    return (
      <div>
        <br />
        <h6 style={{color:txtColor}}>{this.props.lineOne}</h6>
        <h6 style={{color:txtColor}}>{this.props.lineTwo}</h6>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/CustomTextMessage.js